<template>
    <td-dialog
        :title="$t(title)"
        :before-close="settingDialogClose"
        :visible.sync="settingDialogVisible"
        width="748px"
        height="520px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form>
            <td-table height="460px" :columns="nodecolumns" :hasPage="false" :hasMutiSelect="false" :dataSource="nodetableData" :hasLoading="nodeloading" ref="nodetable"> </td-table>
        </el-form>
        <span slot="footer" style="text-align:left">
            <td-button @click="cancel">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
        <!-- 加载dialog -->
        <dialog-MenuDistribut
            v-if="dialogMenuDistributVisible"
            :dialogMenuDistributVisible="dialogMenuDistributVisible"
            :listProInfo="listProInfo"
            :listCsmInfo="listCsmInfo"
            :menuParam="menuParam"
            :templateKey="templateKey"
            :title="menuTitle"
            :isAdd="isAdd"
            @menuDistributDialogClose="menuDistributDialogClose"
            @submit="submit"
        ></dialog-MenuDistribut>
        <!-- 加载dialog -->
        <dialog-user
            v-if="dialogUserVisible"
            :dialogUserVisible="dialogUserVisible"
            :listProInfo="listProInfo"
            :listCsmInfo="listCsmInfo"
            :title="userTitle"
            :isAdd="isAdd"
            :templateKey="templateKey"
            :userParam="userParam"
            @userDialogClose="userDialogClose"
            @submit="submit"
        ></dialog-user>
        <!-- 加载dialog -->
        <dialog-role
            v-if="dialogRoleVisible"
            :dialogRoleVisible="dialogRoleVisible"
            :listProInfo="listProInfo"
            :listCsmInfo="listCsmInfo"
            :title="roleTitle"
            :isAdd="isAdd"
            :roleParam="roleParam"
            :templateKey="templateKey"
            @roleDialogClose="roleDialogClose"
            @submit="submit"
        ></dialog-role>
    </td-dialog>
</template>
<script>
import Api from './../assets/api.js';
import menuDistributDialog from './../components/menuDistributDialog.vue';
import userDialog from './../components/userDialog.vue';
import roleDialog from './../components/roleDialog.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-MenuDistribut': menuDistributDialog,
        'dialog-user': userDialog,
        'dialog-role': roleDialog
    },
    props: ['title', 'settingDialogVisible', 'templateParam', 'listNodeInfo'],
    // 定义变量
    data() {
        return {
            nodeloading: false,
            dialogUserVisible: false,
            dialogRoleVisible: false,
            roleParam: null,
            nodetableData: null,
            templateKey: '',
            dialogMenuDistributVisible: false, // 是否显示dialog
            isAdd: true,
            nodecolumns: [
                //表头
                {
                    prop: 'taskKey',
                    label: 'pgCommon.NODE_KEY',
                    align: 'left',
                    tableWidth: '150',
                    render: (createElement, params) => {
                        if (!params.row.taskKey) {
                            return createElement('div', this.$t('pgCommon.RESERVATION_NODATA'));
                        } else {
                            return createElement('div', params.row.taskKey);
                        }
                    }
                },
                {
                    prop: 'taskName',
                    label: 'pgCommon.NODE_CAPTION',
                    align: 'left',
                    tableWidth: '200',
                    render: (createElement, params) => {
                        if (!params.row.taskName) {
                            return createElement('div', this.$t('pgCommon.RESERVATION_NODATA'));
                        } else {
                            return createElement('div', params.row.taskName);
                        }
                    }
                },
                {
                    label: 'pgCommon.OPERATE',
                    align: 'center',
                    tableWidth: '300',
                    render: (createElement, params) => {
                        // let tasks = false;
                        // if (params.row.tasksFlag === '1') {
                        //     tasks = true;
                        // }
                        let list = [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnSetUserNode(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.SET_USER')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnSetRoleNode(params.row);
                                        }
                                    }
                                },
                                this.$t('pgCommon.SET_ROLE')
                            )
                        ];
                        return createElement('div', list);
                    }
                }
            ] //节点列表字段
        };
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.queryNodeData(); // 进行页面初始化数据的加载
    },
    // 定义并实现方法体
    methods: {
        cancel() {
            // 调用父页面Dialog别名为@settingDialogClose的方法
            this.$emit('settingDialogClose');
        },
        // 根据流程模板key值查询节点信息
        //查询节点数据
        queryNodeData: function() {
            this.nodeloading = true;
            // console.info('-------' + this.templateParam.templateId);
            let param = {
                templateId: this.templateParam.templateId,
                templateKey: this.templateParam.templateKey
            };
            Api.getNodeInfo(param, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('queryTemplate', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.loading = false;
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('queryTemplate', response.data.statusMessage);
                    return;
                }
                this.nodetableData = response.data.content;
                this.nodeloading = false;
            });
        },
        save: function(item, tasks) {
            if (tasks) {
                item.tasksFlag = '0';
            } else {
                item.tasksFlag = '1';
            }
            let taskParam = {
                flag: item.tasksFlag,
                taskDefKey: item.taskKey,
                processDefKey: this.templateParam.templateKey,
                proDefId: this.templateParam.templateKey + ':TEMP'
            };
            Api.saveNodeUser(JSON.stringify(taskParam), response => {
                if (response.data.statusCode !== this.$t(this.$common.requestCode.SUCCESS_INFO_CODE)) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('templateManage/saveNodeUser', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.SWITCH_SUCCESS'), type: 'success' });
                // this.queryNodeData();
            });
        },
        // btnSetAduitNode: function(item) {
        //     this.menuTitle = '分配菜单'; // 标题
        //     this.menuParam = item;
        //     this.templateKey = this.templateParam.templateKey;
        //     this.dialogMenuDistributVisible = true;
        // },
        btnSetUserNode: function(item) {
            this.userTitle = this.$t('pgCommon.SET_USER'); // 标题
            this.userParam = item;
            this.templateKey = this.templateParam.templateKey;
            this.dialogUserVisible = true;
        },
        userDialogClose: function() {
            this.dialogUserVisible = false;
        },
        btnSetRoleNode: function(item) {
            this.roleTitle = this.$t('pgCommon.SET_ROLE'); // 标题
            this.roleParam = item;
            this.templateKey = this.templateParam.templateKey;
            this.dialogRoleVisible = true;
        },
        roleDialogClose: function() {
            this.dialogRoleVisible = false;
        },
        // 关闭窗口之前需要调用的方法
        settingDialogClose() {
            this.$emit('settingDialogClose');
            this.settingDialogVisible = false;
        },
        menuDistributDialogClose() {
            this.dialogMenuDistributVisible = false;
        }
    }
};
</script>
